<template>
  <div
    class="columns is-marginless infoBorderReseau"
    :class="{'selectt': infoReseauxNumerique.select}">
    <div class="column is-narrow is-paddingless position_relative">
      <div class="positionDot">
      </div>
      <img class="sizeImgReseau" :src="url">
    </div>
    <div class="column is-paddingless has-background-white">
      <div class="padding_medium">
        <p @click="show = true" class="pointer is-size-7">
          <label class="has-text-default">Nom du réseau</label> <br>
          <strong class="p_size16 has-text-weight-bold has-text-link">
            {{infoReseauxNumerique.libelle}}
          </strong>
        </p>
        <div class="level is-marginless">
          <div class="level-left is-marginless">
            <p
              v-if="tarif"
              class="p_size18 has-text-weight-bold has-text-link">
              {{formatNum(tarif)}}
            </p>
          </div>
          <div class="level-right bottomViolet">
          </div>
        </div>
        <div
          @click="show = true"
          class="pointer columns is-multiline is-marginless is-gap color-icon"
        >
          <div class="column is-half is-paddingless bottomViolet">
            <div
              v-if="infoReseauxNumerique.extensionOpportunite.quantite"
              class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Durée :</label>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{formatDureeNum(infoReseauxNumerique.extensionOpportunite.typeTarification,
                    infoReseauxNumerique.extensionOpportunite.quantite)}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Nombre de d'écrans </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxNumerique.nbFaces}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-half is-paddingless bottomViolet"
            v-if="infoReseauxNumerique.extensionOpportunite.typeTarification">
            <div class="media">
              <b-icon
                icon="cellphone-screenshot"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Mode de diffusion</label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{modeDiff(infoReseauxNumerique.extensionOpportunite.typeTarification)}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="city"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Ville </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxNumerique.ville}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-half is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Format </label><br>
                <p class="p_size14 has-text-link has-text-weight-bold">
                  {{infoReseauxNumerique.format}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="column is-12 is-paddingless bottomViolet"
            v-if="infoReseauxNumerique.extensionOpportunite.commentaire">
            <div class="media">
              <div class="media-content is-size-7">
                <label class="has-text-weight-bold has-text-link p_size14">
                  Commentaire : </label><br>
                <p class="p_size12 has-text-default has-text-link">
                  {{infoReseauxNumerique.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-narrow">
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme pointer" :class="{'icon-select': infoReseauxNumerique.select}"
          @click="contolSelect()">
          <b-icon icon="cart"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px" v-if="!infoReseauxNumerique.select">
          Sélectionner</p>
        <p class="p_size10 has-text-default ml-5px" v-else>
          Retirer</p>
      </div>
      <div class="has-text-centered mb-btnaction">
        <div class="icon-forme topViolet pointer" @click="show = true">
          <b-icon icon="information"
          type="is-white" custom-class="icon-position"></b-icon>
        </div>
        <p class="p_size10 has-text-default ml-5px">
          Plus d'infos</p>
      </div>
      <div class="has-text-centered mb-btnaction topViolet">
        <app-export-excel
              :data="infoReseauxNumerique.listeFaces"
              :nom="infoReseauxNumerique.libelle"
              :show-dimension="false"
              :periode="infoReseauxNumerique.extensionOpportunite.periode ?
                        infoReseauxNumerique.extensionOpportunite.periode :
                        'Non renseigné'"/>
      </div>
    </div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-numerique-complet-diapo
        :bg="bg"
        :detailResauxComplet="infoReseauxNumerique"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';
import exportExcel from '../../exportExcel';
import detailReseauxNumeriqueCompletDiapo from './detailReseauxNumeriqueCompletDiapo';


export default {
  name: 'infoReseauxNumerique',
  props: ['infoReseauxNumerique'],
  components: {
    appExportExcel: exportExcel,
    appDetailReseauxNumeriqueCompletDiapo: detailReseauxNumeriqueCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxNumerique.urlPhoto);
    },
    tarif() {
      if (this.infoReseauxNumerique.extensionOpportunite.tarifNet) {
        return this.infoReseauxNumerique.extensionOpportunite.tarifNet;
      }
      return this.infoReseauxNumerique.extensionOpportunite.tarifHt;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxNumerique.select = !this.infoReseauxNumerique.select;
      if (this.infoReseauxNumerique.select) {
        this.add(this.tarif);
        this.addNbSelect();
      } else {
        this.substract(this.tarif);
        this.substractNbSelect();
      }
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
    formatNum(value) {
      return formatNum(value);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxNumeriques/infoReseauxNumerique.vue